import React, { useState, useEffect } from "react";
import { Capacitor } from "@capacitor/core";
import { StatusBar } from "@capacitor/status-bar";
import { useUser } from "reactfire";
import { applyTheme } from "../utils/theme";
import { createTheme } from "../utils/theme";
import { themes, ConvertRGBtoHex } from "utils/utils";
import { useTranslation } from "react-i18next";

const ExploreContext = React.createContext();

function exploreReducer(state, action) {
  switch (action.type) {
    case "setLeague": {
      return { ...state, league: action.value, leagueList: [] };
    }
    case "setGameType": {
      return { ...state, gameType: action.value, leagueList: [] };
    }
    case "setGameRule": {
      return { ...state, gameRule: action.value, leagueList: [] };
    }
    case "setLeagueList": {
      return { ...state, leagueList: [...state.leagueList, ...action.value] };
    }
    case "setLeagues": {
      return { ...state, leagues: action.value };
    }
    case "setClearFilter": {
      return { ...state, league: 0, gameType: 0, gameRule: 0 };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function ExploreProvider({ children }) {
  const { t, i18n } = useTranslation();

  const [state, dispatch] = React.useReducer(exploreReducer, {
    league: 0,
    leagues: [],
    leagueList: [],
    gameTypes: [
      {
        id: 0,
        title: t("lobby.filter.all"),
        ref: undefined,
      },
      {
        id: 1,
        title: t("common.gametypes.season"),
        ref: 0,
      },
      {
        id: 2,
        title: t("common.gametypes.playoff"),
        ref: 1,
      },
    ],
    gameType: 0,
    gameRules: [
      {
        id: 0,
        title: t("lobby.filter.all"),
        ref: undefined,
      },
      {
        id: 1,
        title: t("common.gametypes.1x2"),
        ref: [0, 4],
      },
      {
        id: 2,
        title: t("common.gametypes.correct_score"),
        ref: [1, 3],
      },
      {
        id: 3,
        title: t("common.gametypes.lms"),
        ref: [2],
      },
    ],
    gameRule: 0,
  });

  const value = { state, dispatch };
  return (
    <ExploreContext.Provider value={value}>{children}</ExploreContext.Provider>
  );
}

function useExplore() {
  const context = React.useContext(ExploreContext);
  if (context === undefined) {
    throw new Error("useEvent must be used within a EventProvider");
  }
  return context;
}

export { ExploreProvider, useExplore };
